// import { InfoOutlineIcon } from "@chakra-ui/icons";
import {
  Box,
  HStack,
  Icon,
  IconButton,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { t } from "i18next";
import { TreatmentScoreBubble } from "../../../../../coding/views/TreatmentScoreBubble";
import { NodeTreatmentsModal } from "../../../../../shared/views/StmModal/NodeTreatmentsModal";
import { Treatment } from "../../../../../osaway/models/OsaNode";
import { InfoOutlineIcon } from "../../../../../shared/views/icons";

interface Props {
  treatments: Treatment[];
  appliedTreatments?: Treatment[];
}
export const NodeTreatments: React.FC<Props> = ({
  treatments,
  appliedTreatments,
}) => {
  const treatmentsModal = useDisclosure();

  return (
    <>
      <Box width="100%">
        <VStack alignItems="stretch">
          {appliedTreatments?.map((treatment, i) => (
            <Text fontSize="xs" key={i} textDecoration="line-through">
              {t(`sdk:treatments.${treatment.type}`)}
            </Text>
          ))}
          {treatments.length ? (
            treatments.map((treatment, i) => (
              <HStack fontSize="xs" key={i} alignItems="start">
                <TreatmentScoreBubble score={treatment.score} />
                <Text>{t(`sdk:treatments.${treatment.type}`)}</Text>
              </HStack>
            ))
          ) : (
            <Text fontSize="sm">{t("map:treatments.empty")}</Text>
          )}

          <IconButton
            alignSelf="end"
            size="sm"
            variant="ghost"
            colorPalette="primary"
            aria-label="Info"
            onClick={treatmentsModal.onOpen}
          >
            <Icon as={InfoOutlineIcon} size="md" />
          </IconButton>
        </VStack>
      </Box>

      {treatmentsModal.open && (
        <NodeTreatmentsModal
          treatments={treatments}
          onClose={treatmentsModal.onClose}
        />
      )}
    </>
  );
};
